const smallCard = ({ image1, status, count, image2, rating, need }) => {
  const getRatingStyle = ({ rating }) => {
    const baseStyle =
      "h-3.5 w-6 mr-8 text-center flex justify-center items-center ml-2 rounded text-xs  px-4";

    if (rating.includes("+")) {
      return `${baseStyle} bg-green-100 text-green-700`;
    } else if (rating.includes("-")) {
      return `${baseStyle} bg-red-100 text-red-700 `;
    } else {
      return `${baseStyle} bg-[#E0EDF0] text-[#504EFF] text-[8px]`;
    }
  };

  return (
    <div className="flex justify-between items-center flex-[0.5]  h-12 rounded-xl border border-[#D7E4EB] m-2 mt-2.5 mb-5 bg-white">
      <div className="flex flex-row items-center">
        <img src={image1} className="h-5 w-5 ml-8" alt="status icon" />
        <p className={`text-[14px] ml-2.5`}>{status}</p>
      </div>
      <div className="flex flex-row items-center ">
        <p
          className="font-medium text-[14px]"
          style={need === "space" ? { marginRight: 50 } : undefined}
        >
          {count}
        </p>
        {image2 && <img src={image2} className="h-6 w-6 mr-10" alt="additional icon" />}
        {rating && (
          <div className={getRatingStyle({ rating })} style={{ marginLeft: rating ? 10 : 0 }}>
            <p className="text-[8px] ">{rating}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default smallCard;
